import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledDateRangeMonthRadioGroup, StyledDateRangeMonthRadioItem} from './style'
import {YearSemesterEnum} from '@/types'
import {useTranslation} from '@/translations/i18n'

interface DateRangeSemesterSelectorProps {
    selectedSemester: YearSemesterEnum
    onSemesterChange: (semester: YearSemesterEnum) => void
    disabled?: boolean
}

const semesters = [
    {
        labelKey: 'dashboard:semester_1',
        value: 'jan_jun'
    },
    {
        labelKey: 'dashboard:semester_2',
        value: 'jul_dec'
    }
] as const satisfies {labelKey: string; value: YearSemesterEnum}[]

export const DateRangeSemesterSelector = ({
    selectedSemester,
    onSemesterChange,
    disabled
}: DateRangeSemesterSelectorProps) => {
    const {t} = useTranslation()

    const handleSemesterSelect = (value: string) => {
        if (value) {
            onSemesterChange(value as YearSemesterEnum)
        }
    }

    return (
        <StyledDateRangeMonthRadioGroup type="single" value={selectedSemester} onValueChange={handleSemesterSelect}>
            <Flexbox direction="column" gap={3} fullWidth align="stretch">
                {semesters.map(semester => (
                    <StyledDateRangeMonthRadioItem
                        key={semester.value}
                        value={semester.value}
                        $isSelected={selectedSemester === semester.value}
                        $isDisabled={disabled}
                    >
                        {t(semester.labelKey)}
                    </StyledDateRangeMonthRadioItem>
                ))}
            </Flexbox>
        </StyledDateRangeMonthRadioGroup>
    )
}
